<p-dialog
  [header]="customTitle || 'Add New Third Party'"
  [dismissableMask]="true"
  [(visible)]="isModalVisible"
  [modal]="true"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="handleModalHide()"
>
  <form [formGroup]="thirdPartyForm" class="form">
    <app-input-field
      [disabled]="!!preSelectedTypeId"
      [form]="thirdPartyForm"
      [type]="InputFieldType.Dropdown"
      [options]="thirdPartyTypesOptions"
      [optionsLoading]="thirdPartyTypesOptionsLoading"
      controlName="type_id"
      label="Type"
      placeholder="Select Type"
    ></app-input-field>
    <ng-container *ngIf="preSelectedTypeId !== 1">
      <app-input-field
        [form]="thirdPartyForm"
        controlName="name"
        label="Company"
        placeholder="Company Name"
      ></app-input-field>
      <app-input-field
        [form]="thirdPartyForm"
        [type]="InputFieldType.Dropdown"
        [options]="titlesOptions"
        [optionsLoading]="titlesOptionsLoading"
        controlName="title_id"
        label="Title"
        placeholder="Select Title"
      ></app-input-field>
    </ng-container>

    <app-input-field
      [form]="thirdPartyForm"
      controlName="internal_code"
      label="Internal Code"
      placeholder="Internal Code"
    ></app-input-field>

    <div class="form-row">
      <app-input-field
        [form]="thirdPartyForm"
        controlName="first_name"
        label="First Name"
        placeholder="Enter First Name"
      ></app-input-field>
      <app-input-field
        [form]="thirdPartyForm"
        controlName="middle_name"
        label="Middle Name"
        placeholder="Enter Middle Name"
      ></app-input-field>
      <app-input-field
        [form]="thirdPartyForm"
        controlName="last_name"
        label="Last Name"
        placeholder="Enter Last Name"
      ></app-input-field>
    </div>
    <div class="form-row">
      <app-input-field
        [form]="thirdPartyForm"
        controlName="mobile"
        mask="(000) 000-0000"
        label="Phone Number"
        placeholder="Enter Mobile Phone Number"
      ></app-input-field>
      <app-input-field
        [form]="thirdPartyForm"
        controlName="email"
        label="Email"
        placeholder="Enter Email Address"
      ></app-input-field>
    </div>
    <app-input-field
      [form]="thirdPartyForm"
      controlName="url"
      label="Website"
      placeholder="Enter Website"
    ></app-input-field>
    <app-address-component [addressForm]="formAddress"></app-address-component>
    <app-input-field
      [form]="thirdPartyForm"
      [type]="InputFieldType.Dropdown"
      [options]="STATUS_OPTIONS"
      controlName="status"
      optionValue="name"
      label="Status"
      placeholder="Select Status"
    ></app-input-field>
    <app-ngx-loader [loading]="isLoading"></app-ngx-loader>
  </form>
  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button class="cancel-btn" (click)="toggleModal()">Cancel</button>
      <button (click)="handleFormSubmit()" class="custom-btn">Confirm</button>
    </div>
  </ng-template>
</p-dialog>
